/* eslint-disable no-loop-func */
import { useEffect, useRef, useState } from "react";
import logo from "./agent.png"
import title_logo from "./app-logo.png"
import title_logo_en from "./app-logo-en.png"
import './chatui-theme.css';
import './chat-list.css';
import $ from "jquery";
import "./icon-2.0.2.js"
import locales from "./locales/en"
import queryString from "query-string";
import Chat, { Avatar, MessageProps, useMessages, IconButtonProps, QuickReplyItemProps, toast, Bubble, Card, CardTitle, Button, CardText } from '@chatui/core';
const CryptoJS = require("crypto-js");
const showdown = require('showdown');

function ChatOpen() {
    const converter = new showdown.Converter({ tables: true });
    document.title = "CTI-AI";
    const { messages, appendMsg, setTyping, updateMsg } = useMessages([]);
    const userIdRef = useRef(uuidv5(8));
    const sessionIdRef = useRef<string>();
    const isEndRef = useRef<boolean>();
    const waitSecondsIntervalRef = useRef<any>();
    const sourceRef = useRef<any>();
    const lang = useRef<any>();

    const [waitSeconds, setWaitSeconds] = useState('');

    useEffect(() => {
        let params = queryString.parse(window.location.search);
        Object.keys(params).forEach((item) => {
            const key = item.toLocaleLowerCase();
            switch (key) {
                case "source":
                    sourceRef.current = params[item];
                    break;
                case "lang":
                    lang.current = params[item];
                    break;
            }
        });

        if (lang.current === 'en') {
            global.welcomeMessage = "Welcome to Centre Testing International Group Co., Ltd. CTI is the pioneer and leader in the TIC Industry which provides one-stop solutions on testing, inspection, certification, calibration, audit, training & technical services."
            global.aiAskMessage = "Hi I'm Anna! How can I assist you today?"
        }

        sessionIdRef.current = uuidv5(8);
        if (global.welcomeMessage) {
            appendMsg({
                type: "text",
                content: { text: global.welcomeMessage }
            });
        }
        if (global.aiAskMessage) {
            setTyping(true);
            setTimeout(() => {
                appendMsg({
                    type: 'text',
                    content: { text: global.aiAskMessage },
                });
            }, 1000);
        }
        //getIpAddress()
    }, []);

    useEffect(() => {
        const listener = async (e: any) => {
            if (!isEndRef.current) {
                await fetch(`${decryptHex(global.apiBaseUrl, "AES", STORE_KEY)}/Agent/end`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        method: "post",
                        body: JSON.stringify({
                            sessionId: sessionIdRef.current,
                            userId: userIdRef.current
                        })
                    }
                );
            }
        };

        window.addEventListener('beforeunload', listener);

        return (): void => {
            window.removeEventListener('beforeunload', listener);
        };
    });

    //async function getIpAddress() {
    //    const source = await fetch(`http://pv.sohu.com/cityjson?ie=utf-8`,
    //        {
    //            headers: {
    //                "Content-Type": "application/json",
    //            },
    //            method: "get",
    //        }
    //    );
    //    source.text().then(function (text: string) {
    //        if (text) {
    //            try {
    //                var item = JSON.parse(text);
    //                console.log(item)
    //            } catch (e) {
    //                console.log(e);
    //            }
    //        }
    //    });

    //}

    const makedownToHtml = (text: string) => {
        return converter.makeHtml(text);
    }

   
    function uuidv5(len: number, radix: number | undefined = undefined) {
        var chars =
            "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
        var uuid = [],
            i;
        radix = radix || chars.length;

        if (len) {
            for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
        } else {
            var r;
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
            uuid[14] = "4";
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | (Math.random() * 16);
                    uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return uuid.join("");
    }

    async function handleSend(type: string, val: string) {
        const quickReplyArray = ['human', 'nohuman', 'report', 'contact', 'recruit', 'complaints']
        if (quickReplyArray.indexOf(val) !== -1) {

            let quickReplyMessage = '';
            if (lang.current === 'en') {
                let quickReplyText_en = locales.defaultQuickReplies_en.find(e => e.code === val)?.name;
                appendMsg({
                    type: type,
                    content: { text: quickReplyText_en },
                    position: 'right',
                });
                setTyping(true);
                switch (val) {
                    case 'human': quickReplyMessage = isWorkingDateTime() ? locales.humanReplyMessage : locales.nohumanReplyMessage; break;
                    case 'nohuman': quickReplyMessage = locales.nohumanReplyMessage; break;
                    case 'report': quickReplyMessage = locales.reportReplayMessage; break;
                    case 'contact': quickReplyMessage = locales.contactReplyMessage; break;
                    case 'recruit': quickReplyMessage = locales.recruitReplyMessage; break;
                    case 'complaints': quickReplyMessage = locales.complaintsReplyMessage; break;
                }
            } else {
                let quickReplyText = defaultQuickReplies.find(e => e.code === val)?.name;
                appendMsg({
                    type: type,
                    content: { text: quickReplyText },
                    position: 'right',
                });
                setTyping(true);
                switch (val) {
                    case 'human': quickReplyMessage = isWorkingDateTime() ? humanReplyMessage : nohumanReplyMessage; break;
                    case 'nohuman': quickReplyMessage = nohumanReplyMessage; break;
                    case 'report': quickReplyMessage = reportReplayMessage; break;
                    case 'contact': quickReplyMessage = contactReplyMessage; break;
                    case 'recruit': quickReplyMessage = recruitReplyMessage; break;
                    case 'complaints': quickReplyMessage = complaintsReplyMessage; break;
                }
            }          
            //模拟回复消息
            return setTimeout(() => {
                appendMsg({
                    type: type,
                    content: { text: quickReplyMessage },
                });
            }, 1000);
        }

        appendMsg({
            type: 'text',
            content: { text: val },
            position: 'right',
        });
        setTyping(true);

        //判断聊天内容是否包含固定回复
        let fixedQuestionReply = getFixedQuestionReply(val);
        if (fixedQuestionReply.length > 0) {
            return setTimeout(() => {
                appendMsg({
                    type: 'text',
                    content: { text: fixedQuestionReply },
                });
            }, 1000);
        }

        let createdAt = new Date().toISOString();
        promptStream(val, createdAt);

    }

    const promptStream = async (val: string, createdAt: string) => {
        var source: any;
        let guid: string = "";
        source = await fetch(`${decryptHex(global.apiBaseUrl, "AES", STORE_KEY)}/Agent/chat`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Ocp-Apim-Subscription-Key": decryptHex(global.apimKey, "AES", STORE_KEY)
                },
                method: "post",
                body: JSON.stringify({
                    sessionId: sessionIdRef.current,
                    userid: userIdRef.current,
                    ask: val,
                    source: sourceRef.current ?? "AI Agent",
                    lang: lang.current ?? ""
                })
            }
        );
        noStreamingSource(source, guid, createdAt);
    }

    const noStreamingSource = async (source: any, guid: string, createdAt: string) => {
        source.text().then(function (text: string) {
            if (text) {
                let message = "";
                try {
                    var item = JSON.parse(text);
                    isEndRef.current = item.isEnd
                    if (item.isEnd) {
                        sessionIdRef.current = uuidv5(8);
                    }
                    if (item.newSessionWaitSeconds > 0) {
                        let seconds = item.newSessionWaitSeconds;
                        waitSecondsIntervalRef.current = setInterval(() => {
                            seconds = seconds - 1;
                            if (seconds === 0) {
                                setWaitSeconds('');
                                $(".Composer").show();
                                if (waitSecondsIntervalRef.current) {
                                    clearInterval(waitSecondsIntervalRef.current);
                                }
                            }
                            else {
                                $(".Composer").hide();
                                setWaitSeconds(`${seconds}s`);
                            }
                        }, 1000)
                    }
                    //解决不显示emoji表情
                    let completion = unicodeToChar(item.message);
                    //解决不换行的问题
                    completion = completion.replace(/^\"|\"$/g, "").replace(/\\n/g, "\n");
                    //去除斜杠
                    completion = completion.replace(/\\/g, '');
                    message += completion;
                    if (guid.length > 0) {
                        updateMsg(guid, {
                            type: "text",
                            content: { text: message },
                            _id: guid,
                            createdAt: parseInt(createdAt)
                        });
                    }
                    else {
                        guid = uuidv5(8);
                        appendMsg({
                            type: "text",
                            content: { text: message },
                            _id: guid,
                            createdAt: parseInt(createdAt)
                        });
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        });
    }

    const unicodeToChar = (text: string) => {
        return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
            return String.fromCharCode(parseInt(match.replace(/\\u/gi, ''), 16));
        });
    }

    const rightStyle = {
        backgroundColor: "var(--button-primary-color)",
        color: "white",
        marginTop: "2px",
        padding: "18px",
        maxWidth: global.isMobile ? "21.5rem" : "62.5rem"
    };

    const leftStyle = {
        marginTop: "6px",
        padding: "18px",
        color: "#333",
        backgroundColor: "white",
        maxWidth: global.isMobile ? "21.5rem" : "62.5rem",
    };

    const leftContentProps: IconButtonProps = {
        icon: "sign-out",
        onClick: async () => {
            const source = await fetch(`${decryptHex(global.apiBaseUrl, "AES", STORE_KEY)}/Agent/end`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "post",
                    body: JSON.stringify({
                        sessionId: sessionIdRef.current,
                    })
                }
            );
            source.text().then(function (text: string) {
                if (text) {
                    try {
                        var item = JSON.parse(text);
                        if (item.isEnd) {
                            sessionIdRef.current = uuidv5(8);
                        }
                        //let seconds = 15;
                        //waitSecondsIntervalRef.current = setInterval(() => {
                        //    seconds = seconds - 1;
                        //    if (seconds <= 0) {
                        //        setWaitSeconds('');
                        //        $(".Composer").show();
                        //        $(".ScrollView").show();
                        //        if (waitSecondsIntervalRef.current) {
                        //            clearInterval(waitSecondsIntervalRef.current);
                        //        }
                        //    }
                        //    else {
                        //        $(".Composer").hide();
                        //        $(".ScrollView").hide();
                        //        setWaitSeconds(`${seconds}s`);
                        //    }
                        //}, 1000)
                        toast.success('已结束聊天');
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        }
    };

    const rightContentProps: IconButtonProps[] = [
        {
            icon: 'plus-circle',
            onClick: async () => {
                if (window.self !== window.top) {
                    // 当前页面是在iframe中打开的
                    console.log("当前页面是在iframe中打开的");
                    //var parentWindow = window.parent;
                    window.parent.postMessage('window-max', '*');
                } else {
                    // 当前页面是顶层页面
                    console.log("当前页面是是顶层页面");
                    window.close()
                }      
            }
        }, {
            icon: 'close-circle',
            onClick: async () => {
                if (window.self !== window.top) {
                    // 当前页面是在iframe中打开的
                    console.log("当前页面是在iframe中打开的");
                    //var parentWindow = window.parent;
                    window.parent.postMessage('window-close', '*');
                } else {
                    // 当前页面是顶层页面
                    console.log("当前页面是是顶层页面");
                    window.close()
                }                
            }
        }        
    ];
    function renderMessageContent(msg: MessageProps) {
        const { content } = msg;
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {
                    msg.position === "left" &&
                    <div style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
                        <Avatar src={logo} size="lg" />
                        <span style={{ fontSize: ".8rem", marginLeft: "6px", color: "#8C8C8C" }}>{global.aiName}</span>
                    </div>
                }
                <div className="Bubble text" style={msg.position === "right" ? rightStyle : leftStyle}>
                    {
                        msg.position === "left" ?
                            <p dangerouslySetInnerHTML={{ __html: makedownToHtml(content.text) }} /> :
                            content.text
                    }
                </div>
            </div>
        );
    }

    const isWorkingDateTime = () => {
        let currentDate = new Date();
        //节日特殊判断
        var beginDate = new Date("2024-10-01"),
            endDate = new Date("2024-10-07");
        if (currentDate >= beginDate && currentDate <= endDate) {
            return false;
        } 
        const isWeekday = currentDate.getDay() % 6 !== 0;
        if (isWeekday && (currentDate.getHours() >= 8 && currentDate.getHours() < 18)) {
            return true;
        }
        return false;
    }

    function getFixedQuestionReply(msg: string) {
        //fixed question words
        const humanArrary = ['人工']
        const reportArray = ['查报告', '查询报告', '验证码', '证书查询', '报告查询', '查询证书', '查询真伪', '真伪查询', '验证报告', '报告验证', '报告真伪', "检测报告", "报告编号","下载"]
        const contactArray = ['联系方式', '电话', '官方联系', '工作号码', '联络方式']
        const recruitArray = ['招聘', '找工作', '招人', '招工']
        const complaintsArray = ['投诉', '建议']
        if (isMatchedArray(humanArrary, msg)) {
            return isWorkingDateTime() ? humanReplyMessage : nohumanReplyMessage;
        }
        if (isMatchedArray(reportArray, msg)) return reportReplayMessage;
        if (isMatchedArray(contactArray, msg)) return contactReplyMessage;
        if (isMatchedArray(recruitArray, msg)) return recruitReplyMessage;
        if (isMatchedArray(complaintsArray, msg)) return complaintsReplyMessage;
        return "";
    }

    const isMatchedArray = (textArray: any, ask: string) => {
        let result = false;
        for (var i = 0; i < textArray.length; i++) {
            if (ask.indexOf(textArray[i]) !== -1) {
                result = true;
                break;
            }
        }
        return result
    }

    // Using a 256-bit key to ensure we use AES-256
    const STORE_KEY = "qv2eehyt82d7wzmqi7ygaqcee6774vfd";

    const encryptHex = (string: string, chip: string, skey: string) => {
        let result;
        try {
            const key = CryptoJS.enc.Hex.parse(skey);
            if (chip === 'AES') {
                const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
                result = CryptoJS.AES.encrypt(string, key, {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                });
                result = result.ciphertext.toString(CryptoJS.enc.Hex);
            } else {
                result = CryptoJS.HmacSHA256(string, key).toString(CryptoJS.enc.Hex);
            }
            return result;
        } catch (error) {
            throw error;
        }
    };

    const decryptHex = (encryptedStringHex: string, chip: string, skey: string) => {
        let result = '';
        const key = CryptoJS.enc.Hex.parse(skey);
        const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
        try {
            const array = CryptoJS.enc.Hex.parse(encryptedStringHex);
            if (chip === 'AES') {
                result = CryptoJS.AES.decrypt(encryptedStringHex, key, {
                    iv: iv,
                    format: CryptoJS.format.Hex,
                    mode: CryptoJS.mode.CBC,
                }).toString(CryptoJS.enc.Utf8);
            } else {
                result = array;
            }
            return result;
        } catch (error) {
            throw error;
        }
    };

    // 快捷短语回调，可根据 item 数据做出不同的操作，这里以发送文本消息为例
    function handleQuickReplyClick(item: QuickReplyItemProps) {
        handleSend('text', item.code||'');
    }   

    // 默认快捷短语，可选
    const defaultQuickReplies = [
        {
            icon: 'message',
            name: '人工服务',
            code:'human'
        },
        {
            icon: 'search',
            name: '报告验证',
            code: 'report'
        },
        {
            icon:'tel',
            name: '联系方式',
            code: 'contact'
        },
        {
            icon:'info-circle',
            name: '招聘信息',
            code: 'recruit'
        },
        {
            icon:'alarm',
            name: '投诉建议',
            code: 'complaints'
        }
    ];    

    const humanReplyMessage = "请问您想测试什么项目呢？<a href='https://bwt.zoosnet.net/LR/Chatpre.aspx?id=BWT60790040&lng=cn&p=AI-" + sourceRef.current + "'>[人工服务链接]</a>"
    const nohumanReplyMessage = `现在是非工作时间段，您可以给我们<a href='https://www.ctimall.com/ctivue/OfferConsulting'>留言</a>，我们将尽快回复您。谢谢！`
    const reportReplayMessage = `CTI华测报告自助查询方式：\n1、报告查询地址：<a href='https://mycti.cti-cert.com/'>https://mycti.cti-cert.com/</a> →输入报告编号→输入报告验证码（报告第一页右下角NO号）→验证码→报告查询→预览报告，下载报告。\n<img style='width:100%;height:auto;' src='https://mycti.cti-cert.com/Images/Tips/AI-Tips.jpg'>\n2、可通过微信扫描报告中的二维码进行验证。<span style="color:red">（请注意！查询到后，将您手中报告和我司系统报告进行对比是否一致，内容一致即为真实有效的）</span>\n3、报告完整电子版以及您的具体需求或者疑问点以邮件的形式发送到我司邮箱：info@cti-cert.com，我们会请报告组的同事帮忙查询，并会邮件回复您。\n4、以“EED31”和“EED32”开头的报告编号查询报告真伪网址（报告电子版已加密）：<a href='http://yz.cnca.cn/ver-ep/ve/v/pdfveri.jsp'>http://yz.cnca.cn/ver-ep/ve/v/pdfveri.jsp</a>`
    const contactReplyMessage = `CTI华测检测商城在线客服热线\n☎️：400-6788-333\n如遇忙线，请给我们<a href='https://www.ctimall.com/ctivue/OfferConsulting'>留言</a>，我们将尽快回复您。谢谢！`
    const recruitReplyMessage = `华测检测，欢迎您的加入！\n您可以通过以下方式了解我们正在招聘的职位：\n<a href='https://app.mokahr.com/social-recruitment/cti/145979#/'>https://app.mokahr.com/social-recruitment/cti/145979#/</a>`
    const complaintsReplyMessage = `CTI华测检测欢迎您！\n如果您对我们有任何建议或服务过程中有任何问题，可以通过以下方式联系我们，以便及时准确处理您的请求。\n投诉电话：0755-33681700\n建议邮箱：complaint@cti-cert.com\n（请在邮件中写明以下信息：建议/不满意的原因、报告编号、CTI对接人员信息、您的电话和邮箱）`

    //const CardActions = (props: any) => {
    //    return props.children;
    //};

    //function bubblePrompt() {
    //    return (
    //        <>
    //            <Bubble>
    //                <Card size="xl">
    //                    <CardTitle title='请问您是个人还是公司呢？'></CardTitle>
    //                    <CardText></CardText>
    //                    <CardActions>
    //                        <Button>个人</Button>
    //                        <Button color="primary">企业</Button>
    //                    </CardActions>
    //                </Card>
    //            </Bubble>
    //        </>);
    //}
    if (lang.current === 'en') {
        return (
            <>
                <Chat
                    locale="en-US"
                    navbar={{ title: 'AI Service', logo: title_logo_en, leftContent: leftContentProps, rightContent: rightContentProps }}
                    messages={messages}
                    renderMessageContent={renderMessageContent}
                    quickReplies={locales.defaultQuickReplies_en}
                    onQuickReplyClick={handleQuickReplyClick}
                    onSend={handleSend}
                    placeholder='Please enter...'
                />
                {
                    waitSeconds &&
                    <div style={{ position: "absolute", bottom: 10, color: "black", fontSize: "24px", left: "50%", zIndex: 999 }}>
                        {waitSeconds}
                    </div>
                }
            </>
        );
    }
    return (
        <>
            <Chat
                navbar={{ title: 'AI智能客服', logo: title_logo, leftContent: leftContentProps, rightContent: rightContentProps }}
                messages={messages}
                renderMessageContent={renderMessageContent}
                quickReplies={defaultQuickReplies}
                onQuickReplyClick={handleQuickReplyClick}
                onSend={handleSend}
                />
            {
                waitSeconds &&
                <div style={{ position: "absolute", bottom: 10, color: "black", fontSize: "24px", left: "50%", zIndex: 999 }}>
                    {waitSeconds}
                </div>
            }
        </>
    );
}
export default ChatOpen;
